var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.93262C7 4.82805 7.89543 3.93262 9 3.93262H15.1716C15.702 3.93262 16.2107 4.14333 16.5858 4.51841L19.4142 7.34683C19.7893 7.72191 20 8.23061 20 8.76105V16.9326C20 18.0372 19.1046 18.9326 18 18.9326H9C7.89543 18.9326 7 18.0372 7 16.9326V5.93262Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.93262C4.89543 6.93262 4 7.82805 4 8.93262V19.9326C4 21.0372 4.89543 21.9326 6 21.9326H16C17.1046 21.9326 18 21.0372 18 19.9326",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.b389b468.svg";
export { ForwardRef as ReactComponent };